export default function VerticalDivider() {
  return (
    <span className="flex grow-0 w-[2px] h-[16px] overflow-hidden border-l-[2px] border_primary" />
  );
}
